import { FunctionComponent } from 'react'
import { RoundedButton } from '../../shared'
import { AgentProfilePicker } from '../AgentProfilePicker'
import { StarterPanelProps } from './StarterPanel.model'
import styles from './StarterPanel.module.scss'

export const StarterPanel: FunctionComponent<StarterPanelProps> = ({
  profiles,
  agentProfile,
  disabled,
  onAgentProfileChange,
  onSelect,
}) => {
  // Suggestions définies par profil dans config/stats_assistant/agents.yaml (back).
  const suggestions = profiles.find((profile) => profile.key === agentProfile)?.suggestions ?? []

  return (
    <div>
      <AgentProfilePicker
        profiles={profiles}
        value={agentProfile}
        disabled={disabled}
        onChange={onAgentProfileChange}
      />
      {suggestions.length > 0 && (
        <>
          <div className={styles.suggestionsTitle}>Suggestions</div>
          <div className={styles.suggestions}>
            {suggestions.map((question, index) => (
              <RoundedButton
                key={question}
                label={question}
                theme="transparent-dark"
                size="micro"
                disabled={disabled}
                onClick={() => onSelect(question)}
                testId={`button-stats_assistant-suggestion-${index}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}
